import * as Raven from 'raven-js';
import * as config from './config';

export function initTelemetry() {
  Raven.config(config.sentryDSN, { release: config.sentryRelease }).install();

  // This is a partially-standardized API called in some browsers when there
  // is an unhandled promise rejection. There's some useful info at
  // https://github.com/getsentry/raven-js/issues/424
  (window as any).onunhandledrejection = (e: any) => {
    Raven.captureException(e.reason || e);
  };
}

export function reportError(e: Error, options?: Raven.RavenOptions) {
  Raven.captureException(e, options);
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/telemetry.ts